// Применение дизайн-токенов бренда к документу.
// Вызывается в src/index.js ДО первого рендера: цвета приходят только из
// бренд-пака (src/brand.js), в styles.css остаются лишь var()-ссылки.
import BRAND from './brand';

const TOKEN_TO_VAR = {
  primary: '--primary-color',
  primaryHover: '--primary-hover',
  primaryLight: '--primary-light',
  onPrimary: '--on-primary',
  primarySoftBg: '--primary-soft-bg',
  bg: '--bg-color',
  text: '--text-color',
  textSecondary: '--text-secondary',
  cardBg: '--card-bg',
  border: '--border-color',
  success: '--success-color',
  fontHeading: '--font-heading',
  fontBody: '--font-body',
};

export function applyTheme() {
  const theme = BRAND.theme;
  if (!theme) {
    throw new Error(`У бренда "${BRAND.name}" нет темы (theme) в src/brand.js`);
  }
  const missing = Object.keys(TOKEN_TO_VAR).filter((k) => !theme[k]);
  if (missing.length) {
    throw new Error(`Тема бренда "${BRAND.name}" неполная, не заданы токены: ${missing.join(', ')}`);
  }
  const root = document.documentElement;
  // Атрибут бренда: позволяет в styles.css писать пер-брендовые секции
  // вида [data-brand="bloooom"] .catalog-tab {...} — другие бренды не затрагиваются
  root.dataset.brand = BRAND.key;
  Object.entries(TOKEN_TO_VAR).forEach(([token, cssVar]) => {
    root.style.setProperty(cssVar, theme[token]);
  });
  // Синхронизируем цвет браузерной шапки с темой
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme.primary);
}
